<template>
  <v-flex xs12>
    <h2>Welkom op het Projectplatform van <i>Geef ze de Vijf!</i></h2>

    <p>
      Je hebt als praktiserend melkveehouder gekozen voor deelname aan het
      project Geef ze de Vijf!<br>
      De deelname is zoveel mogelijk toegesneden op de eigen bedrijfssituatie en
      dat betekent dat we afspraken met je maken over de precieze invulling. We
      vragen je daarom contact met ons op te nemen.
    </p>

    <p>
      Met deelname aan het project heb je ook toegang tot het discussieplatform
      en het kennisplatform.<br>
      Als melkveehouder kun je ook mee doen aan de bedrijfsvergelijking. Wij
      vragen je daarvoor een aantal bedrijfskengetallen in te vullen. Voor de
      huidige situatie en voor de situatie die je in de toekomst wilt bereiken.
      We berekenen op basis daarvan ook het levenssaldo voor de beide
      situaties.<br>
      De ingevulde lijst van de huidige situatie wordt automatisch naar ons
      verstuurd zodat we kunnen meekijken of alles goed is ingevuld. Na deze
      check kun je de streefwaarden invullen.
    </p>

    <p>
      Op een dashboard kun je jouw situatie vergelijken met het gemiddelde van
      de andere deelnemers. En natuurlijk kun je daarover met de andere
      deelnemers in overleg gaan via het discussieplatform.<br>
      Heb je vragen? Mail, bel of whatsapp dan zodat we je verder kunnen helpen.
    </p>

    <p>
      In het menu in de linker bovenhoek kun je kiezen voor de verschillende
      onderdelen of om je profiel eventueel aan te passen.
    </p>

    <p>
      Wij wensen je een vruchtbaar gebruik van het platform. Samen gaan we voor
      een gezonde en probleemloze veestapel met een lange levensduur.
    </p>

    <p>
      <b>Updates</b><br>
      Het platform wordt zo actueel mogelijk gehouden. Nieuwe informatie op het
      platform melden wij via onze nieuwsbrief. Meld je daarom ook aan voor de
      nieuwsbrief.
    </p>
  </v-flex>
</template>
<script>
export default {
  name: 'UserDashboard',
}
</script>
